<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="身份：">
        <el-select v-model="query.levelId" placeholder="请选择" clearable size="small" style="width: 300px;">
          <el-option :label="item.name" :value="item.level" v-for="item in standingList" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学习时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import courseRecordApi from '@/api/course/courseRecord'
import customerLevelApi from '@/api/sys/customerLevel'
import technicalServiceLevelApi from '@/api/sys/technicalServiceLevel'
export default {
  props: ['isIntegral'],
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
        levelId:null
      },
      standingList:[]
    }
  },
  created() {
    // this.sectionList=JSON.parse(localStorage.getItem('levelList'))
    this.getBusinessStanding()
    this.getOption()
  },
  methods: {
    // 获取业务员身份
    getBusinessStanding() {
      customerLevelApi.fetchList().then(({
        data
      }) => {
        this.standingList.push(...data)
        // console.log('客户身份: ', data);
      })
    },
    // 获取客户
    getOption() {
      technicalServiceLevelApi.findOptions().then(({
        data
      }) => {
        let arr=data.mpa(i=>({name:i.value,level:i.key}))
        this.standingList.push(...arr)
      })
    },
    handleDownload() {
      let query={...this.query}
      if(!query.levelId) delete query.levelId
      query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : ""
      query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : ""
      return this.$common.confirm('是否确认导出')
        .then(() => courseRecordApi.exportExcel(query)).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 1000)
          }
        })
    },
  }
}
</script>

<style lang="scss">
  // ::v-deep .el-input{
  //   width: 400px !important;
  // }
</style>
